import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const ServicesDetailed: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const services = (c.services || []) as Array<{ title: string; description: string; image_url?: string; bullets?: string; cta_text?: string; cta_url?: string }>;

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 48 }}
        >
          {sfHeadline(c, 'Our Services')}
        </InlineEditText>
        {services.map((s, i) => {
          const bullets = s.bullets ? (typeof s.bullets === 'string' ? s.bullets.split(',') : s.bullets) : [];
          return (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center', marginBottom: 64 }}>
              <div style={{ order: i % 2 === 1 ? 1 : 0 }}>
                <h3 style={{ fontSize: '1.5rem', marginBottom: 12 }}>{s.title}</h3>
                <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: 16 }}>{s.description}</p>
                {bullets.length > 0 && (
                  <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
                    {(bullets as string[]).map((b: string, bi: number) => <li key={bi} style={{ color: '#64748b', marginBottom: 4 }}>{typeof b === 'string' ? b.trim() : b}</li>)}
                  </ul>
                )}
                {s.cta_text && (
                  <a href={s.cta_url || '#'} className="sb-cta-btn" style={{ display: 'inline-block', padding: '10px 24px', borderRadius: 6, background: 'var(--brand-primary, #1a365d)', color: '#fff', fontWeight: 600, textDecoration: 'none' }}>
                    {s.cta_text}
                  </a>
                )}
              </div>
              <div>
                {s.image_url ? <img src={s.image_url} alt="" style={{ width: '100%', borderRadius: 12 }} /> : <div style={{ background: '#f1f5f9', borderRadius: 12, aspectRatio: '4/3' }} />}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
export default ServicesDetailed;
